import React from 'react';

import { Container } from '../../components/container';
import { LoginForm, ILoginFormProps } from '../../modules/login-form';

const TemplateLogin = (props: ILoginFormProps): JSX.Element => (
    <Container>
        <LoginForm {...props} />
    </Container>
);

export default TemplateLogin;
